"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractVpcService2 = _interopRequireDefault(require("../AbstractVpcService"));

var _ServiceSettings = _interopRequireDefault(require("../../../ServiceSettings"));

var _ServiceUrlUtility = _interopRequireDefault(require("../../../util/ServiceUrlUtility"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var QA_BASE_URL = 'https://api.dexf.qa.ikeadt.com/vpc/v1/configurations/retailunit/{retailUnit}/locale/{locale}';
var QA_API_KEY = '7d0efd34-5c8e-4b6c-b0ec-4446f91bec4a';
/**
 * This class is used for saving planner configurations to the IKEA VPC service.
 */

var DexfVpcService = /*#__PURE__*/function (_AbstractVpcService) {
  _inherits(DexfVpcService, _AbstractVpcService);

  var _super = _createSuper(DexfVpcService);

  /**
   * Class constructor.
   */
  function DexfVpcService() {
    var _this;

    _classCallCheck(this, DexfVpcService);

    _this = _super.call(this);
    _this.configurationVersion = '1.0';
    return _this;
  }
  /**
   * Saves a planner configuration.
   *
   * @override
   * @param {VpcServiceConfig} vpcConfig Service config for VPC.
   * @param {object} productConfig Product configuration object.
   * @param {object[]} shoppingList Shopping list.
   * @returns {Promise} Promise object.
   */


  _createClass(DexfVpcService, [{
    key: "saveConfiguration",
    value: function saveConfiguration(vpcConfig, productConfig, shoppingList) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        delete productConfig.configurationSource;
        fetch(_this2._getUrl(vpcConfig), {
          method: 'POST',
          body: _this2._getRequestBody(productConfig, shoppingList),
          credentials: 'same-origin',
          headers: {
            'dexf-api-key': _this2._getApiKey(vpcConfig),
            'content-type': 'application/json'
          }
        }).then(_this2._handleJsonResponse.bind(_this2)).then(function (response) {
          if (response.configurationId) {
            resolve(response.configurationId);
          } else {
            resolve(response);
          }
        }).catch(_this2._rejectWrapper.bind(_this2, reject));
      });
    }
    /**
     * Fetches and returns a planner configuration.
     *
     * @override
     * @param {VpcServiceConfig} vpcConfig Service config for VPC.
     * @param {string} productConfigId Product configuration id.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "getConfiguration",
    value: function getConfiguration(vpcConfig, productConfigId) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        fetch(_this3._getUrl(vpcConfig) + '/' + productConfigId.toUpperCase(), {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'dexf-api-key': _this3._getApiKey(vpcConfig)
          }
        }).then(_this3._handleJsonResponse.bind(_this3)).then(function (data) {
          var parsedData = _this3._parseResponse(data, vpcConfig.acceptableConfigurationSources);

          if (parsedData !== null) {
            resolve(parsedData);
          } else {
            reject(new _ServiceException.default('Failed to parse VPC data from response. The format was not correct.', _this3.constructor.factoryName));
          }
        }).catch(_this3._rejectWrapper.bind(_this3, reject));
      });
    }
    /**
     * Returns the base URL to be used in request.
     *
     * @param {VpcServiceConfig} vpcConfig Service config for VPC.
     * @returns {string} Base URL.
     */

  }, {
    key: "_getUrl",
    value: function _getUrl(vpcConfig) {
      var retailUnit = vpcConfig.apiLocalePath.substr(0, 2).toUpperCase();
      var languageCode = vpcConfig.apiLocalePath.substr(3, 2);
      var locale = languageCode + '-' + retailUnit;
      return (this._getBaseUrl(vpcConfig) || QA_BASE_URL).replace(/{retailUnit}/g, retailUnit).replace(/{locale}/g, locale);
    }
    /**
     * Returns the base url.
     *
     * @param {VpcServiceConfig} vpcConfig Service config for VPC.
     * @returns {string} Service url.
     */

  }, {
    key: "_getBaseUrl",
    value: function _getBaseUrl(vpcConfig) {
      return this._isProduction() ? vpcConfig.endpoints.dexfVpcService : QA_BASE_URL;
    }
    /**
     * Returns API key.
     *
     * @param {VpcServiceConfig} vpcConfig Service config for VPC.
     * @returns {string} API key.
     */

  }, {
    key: "_getApiKey",
    value: function _getApiKey(vpcConfig) {
      return this._isProduction() ? vpcConfig.dexfApiKey : QA_API_KEY;
    }
    /**
     * Checks if it is a production environment.
     *
     * @returns {boolean} TRUE if production.
     */

  }, {
    key: "_isProduction",
    value: function _isProduction() {
      return !_ServiceUrlUtility.default.usingProxy(window.location.hostname) || _ServiceSettings.default.forceProductionDexfVpc;
    }
    /**
     * Parses response data.
     *
     * @param {object} data Data to parse.
     * @param {string[]} [acceptableConfigurationSources] Acceptable configuration sources. Default is "ServiceSettings.applicationName".
     * @returns {object|null} Parsed data.
     */

  }, {
    key: "_parseResponse",
    value: function _parseResponse(data) {
      var acceptableConfigurationSources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var acceptableSources = this._parseConfigurationSources(acceptableConfigurationSources);

      if (data) {
        var application = data.application.toUpperCase();
        var applicationIsAcceptableSource = acceptableSources.find(function (acceptableSource) {
          return acceptableSource.includes(application);
        });

        if (!applicationIsAcceptableSource) {
          throw new _ServiceException.default('Failed to parse VPC data from response. The configuration source "' + application + '" did not match the list of acceptable application names (' + acceptableSources.join(', ') + ').', this.constructor.factoryName);
        }

        return Object.assign(data.configuration.content, {
          configurationSource: application
        });
      }

      return null;
    }
    /**
     * Returns payload to be used when saving a configuration.
     *
     * @param {object} productConfig Product configuration data.
     * @param {object[]} shoppingList Shopping list items.
     * @returns {object|null} Parsed data.
     */

  }, {
    key: "_getRequestBody",
    value: function _getRequestBody(productConfig, shoppingList) {
      return JSON.stringify({
        application: _ServiceSettings.default.applicationName.toUpperCase(),
        itemList: {
          item: shoppingList.map(function (item) {
            return {
              itemType: item.type,
              itemNo: item.id,
              quantity: item.qty
            };
          })
        },
        configuration: {
          version: this.configurationVersion,
          content: productConfig
        }
      });
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @returns {string} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'dexfvpc';
    }
  }]);

  return DexfVpcService;
}(_AbstractVpcService2.default);

exports.default = DexfVpcService;